export const conductorInitialValues = {
  cdCondutorSubstituto: '',
  cdLinha: '',
  cdSolicitacao: '',
  nuCondutor: '',
  nuAno: '',
  deNome: '',
  deCpf: '',
  deCnh: '',
  tpCategoriaCnh: '',
  nuProcesso: '',
  cdProcesso: '',
  dtEmissao: new Date(),
  dtValidade: null,
  boAtivo: true,
  cdUsuarioResponsavel: '',
  linha: {},
  documentos: [],
  permissionarios: [],
};
